export default __webpack_public_path__ + "static/media/icon_resurssit_valmis.8a21d9e0.svg";